import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/components/ui/skeleton';
import ProgressBar from '@appchoose/progress-bar';
import { Loader2 } from 'lucide-react';

interface CompletionBarProps {
  completedCount: number;
  totalCount: number;
  progressValue: number;
  isStreaming?: boolean;
}

function CompletionBar({
  completedCount,
  totalCount,
  progressValue,
  isStreaming = false,
}: CompletionBarProps) {
  const { t } = useTranslation();

  if (isStreaming) {
    return (
      <div className="flex w-[220px] shrink-0 flex-col gap-1 px-4">
        <div className="flex items-center justify-center gap-2 text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="whitespace-nowrap text-xs font-normal">
            {t('ui-v2.components.completion-bar.loading-variants')}
          </span>
        </div>
        <Skeleton className="h-2 w-full rounded-full" />
      </div>
    );
  }

  return (
    <div className="flex w-[220px] shrink-0 flex-col gap-1 px-4">
      <div className="flex items-center justify-center gap-1 whitespace-nowrap">
        <span className="text-sm font-medium">{completedCount}</span>
        <span className="text-xs font-normal text-muted-foreground">
          / {totalCount}{' '}
          {t('ui-v2.components.completion-bar.completed-variants')}
        </span>
      </div>
      <ProgressBar appearance="default" value={progressValue} />
    </div>
  );
}

export default CompletionBar;
